import React, { Component } from 'react';
import AuditBreadcrumb from './auditBreadcrumb';
import { TextField, InputAdornment, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import DateRangeFilter from '../../../common/DateRangeFilter';

class AuditSearchMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div>
                <AuditBreadcrumb onBtnExport={this.props.onBtnExport} />
                <div className="row" style={{ padding: '15px 12px 0 12px' }}>
                    {/* Date Range Section */}
                    <div className="col-6">
                        <DateRangeFilter
                            date_range={this.props.date_range}
                            from_date={this.props.from_date}
                            to_date={this.props.to_date}
                            updateDateRange={this.props.updateDateRange}
                            handleDateFiltersChange={this.props.handleDateFiltersChange}
                        />
                    </div>

                    {/* Filters Row */}
                    <div className="col-6">
                        <div className="row">
                            <div className="col-6 my-2">
                                <FormControl sx={{ minWidth: 250 }}>
                                    <InputLabel>Event Type</InputLabel>
                                    <Select
                                        value={this.props.eventTypeFilter || ''}
                                        label="Event Type"
                                        onChange={(e) => this.props.onEventTypeChange(e.target.value)}
                                    >
                                        <MenuItem value="">
                                            <em>All Event Types</em>
                                        </MenuItem>
                                        {this.props.eventTypes &&
                                            this.props.eventTypes.map((type) => (
                                                <MenuItem key={type} value={type}>
                                                    {type}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className="col-6 my-2">
                                <FormControl sx={{ minWidth: 250 }}>
                                    <InputLabel>User</InputLabel>
                                    <Select
                                        value={this.props.userFilter || ''}
                                        label="User"
                                        onChange={(e) => this.props.onUserChange(e.target.value)}
                                    >
                                        <MenuItem value="">
                                            <em>All Users</em>
                                        </MenuItem>
                                        {this.props.users &&
                                            this.props.users.map((user) => (
                                                <MenuItem key={user} value={user}>
                                                    {user}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className="col-6 my-2">
                                <TextField
                                    label="Search"
                                    placeholder="Search all columns..."
                                    variant="outlined"
                                    id="reset-form"
                                    sx={{ width: 250 }}
                                    onChange={this.props.onFilterTextChange}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon font />
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </div>
                            <div className="col-6 my-2">
                                <button className="btn btn-danger" onClick={() => this.props.clearFilter()}>
                                    <i className="fa fa-times" aria-hidden="true"></i> Clear Filter
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AuditSearchMenu;
